import { useMemo } from "react";

/**
 * Snapshot of a custom view's saved table layout, refreshed only when the
 * selected view id changes. StackTable continuously writes live drafts into
 * selectedView.data; feeding those back into column defs / col order / groups
 * causes update loops when switching views (e.g. My Companies → custom view).
 */
function useSavedViewLayout(selectedView) {
  const viewId = selectedView?.table_view_id;

  return useMemo(() => {
    if (!viewId) {
      return { columns: [], columnOrder: undefined, groupBy: [] };
    }
    const data = selectedView?.data;
    return {
      columns: Array.isArray(data?.columns) ? data.columns : [],
      columnOrder: Array.isArray(data?.columnOrder) ? data.columnOrder : undefined,
      groupBy: Array.isArray(data?.groupBy) ? data.groupBy : []
    };
    // Intentionally only viewId: capture layout at view-select time, ignore live drafts.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewId]);
}

export default useSavedViewLayout;
